const getNonPDPQueryVariables = (id, productSku, hookOptions = {}) => {
  const { skip = false, defaultValue = {} } = hookOptions;

  if (skip) {
    return defaultValue;
  }

  if (id) {
    return { id };
  }

  if (productSku) {
    return { productSku };
  }

  return {};
};

export default getNonPDPQueryVariables;
